<template lang="pug">
div.px-8
  v-row(no-gutters)
    v-col.pr-8.shrink
      div.sticky.white(style="width: 230px; top: 106px;")
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/settings/registration-settings')") Registration settings
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/settings/consultation-settings')") Consultation settings
        .text-md.font-semibold.neutral200.px-6.py-2.round-md.mb-2 Checkout settings

    v-col.grow
      v-container.pt-10
        v-breadcrumbs.pt-0.px-0.pb-3(:items="breadcrumbItems")
          template(v-slot:item="{ item }")
            a.text-sm.font-medium.no-underline.neutral700--text(v-if="!item.disabled" @click="$router.push(item.href)") {{ item.text }}
            .text-sm.neutral700--text(v-else) {{ item.text }}

        .text-2xl.font-semibold.neutral700--text Checkout settings
        panel-payment-method
        self-pay-payment-method
</template>

<script>
import PanelPaymentMethod from '@/components/clinic/settings/PanelPaymentMethod.vue'
import SelfPayPaymentMethod from '@/components/clinic/settings/SelfPayPaymentMethod.vue'

export default {
  components: { PanelPaymentMethod, SelfPayPaymentMethod },
  data: () => ({
    breadcrumbItems: [
      {
        text: 'Clinic management',
        disabled: false,
        href: '/admin/clinic/settings'
      },
      {
        text: 'Checkout settings',
        disabled: true
      }
    ]
  }),
  computed: {},
  watch: {},
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>